// extracted by mini-css-extract-plugin
export default {"table":"DataTable_table__VimPf","new":"DataTable_new__73fI8","updated":"DataTable_updated__05GKL"};